import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
} from "@mui/material";
import PropTypes from "prop-types";
import "./SummaryTable.scss";
import SummaryRow from "./SummaryRow";
import { numberFormatter } from "../../utils/formatter";

const SummaryTable = (props: { data: any }) => {
  const { data } = props;
  const hasValue = data?.noOfCustomer || data?.marginPerDrop?.value || data?.revenue?.value
  type HeaderKeys = 1 | 2 | 3 | 4;
  const findHeader = (val: HeaderKeys) => {
    const headers: Record<HeaderKeys, string> = {
      1: "Reasess and Fix",
      2: "Optimize Margin",
      3: "Grow Customer",
      4: "Price For Profit",
    };
    return headers[val] || "";
  };
  type ColorKeys = 1 | 2 | 3 | 4;
  const getColor = (val: ColorKeys) => {
    const colors: Record<ColorKeys, { bg: string, border: string }> = {
      1: {
        border: "#d55454", bg: "#FAE9E9"
      },
      2: { bg: "#FEFAF1", border: "#c79c38" },
      3: { bg: "#EFF6E1", border: "#008b00" },
      4: { bg: "#E4F0F8", border: "#60b5bf" },
    };
    return colors[val] || "";
  };

  const checkForMarginDrop = () => {
    let numString = data?.marginPerDrop?.value?.toString();

    return Math.sign(data?.marginPerDrop?.value) === 1
      ? "$" + numberFormatter(Math.round(data?.marginPerDrop?.value))
      : "$(" +
      numberFormatter(
        Math.round(Number(numString?.replace(numString[0], "")))
      ) +
      ")";
  };

  return (
    <Box component={"div"} className="bg-white shadow-md">
      <TableContainer>
        <Table
          className="border-[1px] border-[#bebebe] shadow-md"
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  borderBottom: `2px solid ${hasValue ? getColor(data?.selectedValue).border : "#bebebe"}`,
                }}
                className="table-header-text"
                colSpan={3}
              >
                {data?.selectedValue ? (
                  findHeader(data?.selectedValue)
                ) : (
                  <Skeleton
                    variant="text"
                    sx={{
                      fontSize: "0.75vw",
                      margin: "0 auto",
                      // height: "1.5rem",
                    }}
                  />
                )}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <SummaryRow
              label="Revenue"
              value={
                data?.revenue?.value
                  ? "$" + numberFormatter(Math.round(data?.revenue?.value))
                  : "-"
              }
            />
            <SummaryRow
              bgColor={hasValue && getColor(data?.selectedValue).bg}
              label="Net Margin per Drop"
              value={data?.marginPerDrop?.value ? checkForMarginDrop() : "-"}
            />
            <SummaryRow
              label="No. of Customers"
              value={data?.noOfCustomer ? data?.noOfCustomer : "-"}
            />
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

SummaryTable.propTypes = {
  data: PropTypes.object,
};

export default SummaryTable;
